import { cartActions } from "./shared";

/**
 * Stable cart action accessors with no React state.
 * Subscribers never re-render from this hook — use for list Item cards
 * that receive cartQty via props and only need to call mutateCart/setCartOpen.
 */
export default function useCartActions() {
    return {
        mutateCart: (...args) => {
            if (!cartActions.mutateCart) {
                return Promise.reject(new Error("Cart not ready"));
            }
            return cartActions.mutateCart(...args);
        },
        setCartOpen: (...args) => {
            if (cartActions.setCartOpen) {
                cartActions.setCartOpen(...args);
            }
        }
    };
}
